import React, { PureComponent } from "react";
import FieldContainer from "../components/FieldContainer";
import DatePicker from "react-datepicker";
import moment from "moment";
import range from "lodash/range";
import "react-datepicker/dist/react-datepicker.css";

const monthsEn = [
  "01 - January",
  "02 - February",
  "03 - March",
  "04 - April",
  "05 - May",
  "06 - June",
  "07 - July",
  "08 - August",
  "09 - September",
  "10 - October",
  "11 - November",
  "12 - December"
];
const monthsFr = [
  "01 - Janvier",
  "02 - Février",
  "03 - Mars",
  "04 - Avril",
  "05 - Mai",
  "06 - Juin",
  "07 - Juillet",
  "08 - Août",
  "09 - Septembre",
  "10 - Octobre",
  "11 - Novembre",
  "12 - Décembre"
];

function pad(v) {
  if (v < 10) return "0" + v;
  return v;
}

function parseValue(value, format) {
  // TODO : tests...
  // console.log("parseValue", value, format);
  if (!value) return {};
  const date = moment(value, [format, "YYYY-MM-DD", "DD/MM/YYYY", "YYYY/MM/DD"]);
  if (date) {
    return {
      day: date.date(),
      month: date.month() + 1,
      year: date.year()
    };
  }
  return {};
}

class DateSelect extends PureComponent {
  render() {
    const { name, field, options, value, required, onChange } = this.props;
    return (
      <select
        className="af-dateselect-field"
        name={name + "-" + field}
        required={required}
        onChange={e => onChange(field, e.target.value)}
        value={value || ""}
      >
        <option value="" />
        {options.map(option => {
          if (typeof option !== "object")
            return (
              <option key={option} value={option}>
                {option}
              </option>
            );
          const { value, label } = option;
          return (
            <option key={value} value={value}>
              {label}
            </option>
          );
        })}
      </select>
    );
  }
}

export default class DateSelectField extends PureComponent {
  static defaultProps = {
    format: "YYYY-MM-DD"
  };
  state = parseValue(this.props.value, this.props.format);

  pushChange = () => {
    const { name, onChange } = this.props;
    const { day, month, year } = this.state;
    if (day && month && year) {
      const { name, onChange, format } = this.props;
      const date = moment({ years: year, months: month - 1, days: day });
      onChange(name, date.format(format));
    } else {
      onChange(name, "");
    }
  };

  handleChange = (key, value) => {
    this.setState({ [key]: value }, this.pushChange);
  };

  render() {
    const { name, monthsLabels = monthsFr, minYear = 1900, maxYear = 2030, value, required } = this.props;
    const { day, month, year } = this.state;
    // console.log(value, "=>", day, month, year);
    return (
      <FieldContainer {...this.props}>
        {/* Hidden input to upload value... */}
        <input name={name} value={value || ""} readOnly style={{ display: "none" }} required={required} />
        <DateSelect
          name={name}
          field="day"
          options={range(1, 32).map(v => ({ value: v, label: "" + pad(v) }))}
          value={day}
          required={required}
          onChange={this.handleChange}
        />
        <DateSelect
          name={name}
          field="month"
          options={monthsLabels.map((m, index) => ({ value: index + 1, label: m }))}
          required={required}
          value={month}
          onChange={this.handleChange}
        />
        <DateSelect
          name={name}
          field="year"
          options={range(minYear, Number(maxYear) + 1)}
          required={required}
          value={year}
          onChange={this.handleChange}
        />
      </FieldContainer>
    );
  }
}
